/* Quaglia CarPlay – Termin-Assistent (Produktseite) */
(function () {
  var CAM_TEXT = { vorhanden: 'vorhanden – wird angeschlossen', einbauen: 'wird mit eingebaut', keine: 'nicht gewünscht' };

  function init(root) {
    if (root.hasAttribute('data-ready')) return;
    root.setAttribute('data-ready', '');

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var variants = [];
    try { variants = JSON.parse($('[data-q-variants]').textContent); } catch (err) {}
    var camIndex = parseInt(root.getAttribute('data-cam-index'), 10);
    var camWith = root.getAttribute('data-cam-with');
    var camWithout = root.getAttribute('data-cam-without');
    var car = root.getAttribute('data-car');
    var wa = root.getAttribute('data-wa');
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var panels = $$('[data-q-panel]');
    var stepsEl = $('[data-q-steps]');
    var countEl = $('[data-q-count]');
    var navEl = $('[data-q-nav]');
    var backBtn = $('[data-q-back]');
    var nextBtn = $('[data-q-next]');
    var needEl = $('[data-q-need]');
    var cal = $('[data-q-cal]');
    var fileInput = $('[data-q-file]');
    var uploadEl = $('[data-q-upload]');
    var fileNameEl = $('[data-q-file-name]');
    var laterBtn = $('[data-q-photo-later]');
    var checkoutBtn = $('[data-q-checkout]');
    var statusEl = $('[data-q-status]');
    var waBtn = $('[data-q-wa]');

    var state = { i: 0, year: null, cam: null, opts: {}, photo: null, file: null, booked: false, eventId: '', saving: null, saved: false };
    var calSig = '';

    panels.forEach(function (panel, idx) {
      var li = document.createElement('li');
      li.className = 'q-as__step';
      li.innerHTML = '<span class="q-as__step-row"><span class="q-as__dot" aria-hidden="true"></span><span class="q-as__step-label"></span></span>';
      li.querySelector('.q-as__dot').textContent = String(idx + 1);
      li.querySelector('.q-as__step-label').textContent = panel.getAttribute('data-label');
      stepsEl.appendChild(li);
    });
    stepsEl.style.setProperty('--q-as-n', String(panels.length));

    function key(i) { return panels[i] ? panels[i].getAttribute('data-q-panel') : ''; }
    function indexOf(k) {
      for (var i = 0; i < panels.length; i++) { if (key(i) === k) return i; }
      return -1;
    }

    function variant() {
      if (!variants.length) return null;
      var want = variants[0].options.slice();
      for (var k = 0; k < want.length; k++) {
        if (k === camIndex) want[k] = state.cam === 'einbauen' ? camWith : camWithout;
        else if (state.opts[k] != null) want[k] = state.opts[k];
      }
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        var ok = true;
        for (var m = 0; m < want.length; m++) { if (v.options[m] !== want[m]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function yearLabel() {
      if (!state.year) return '';
      return state.year === 'unbekannt' ? 'weiss ich nicht' : String(state.year);
    }

    function optLabels() {
      var out = [];
      $$('[data-q-panel="opt"]').forEach(function (panel) {
        var oi = panel.getAttribute('data-opt-index');
        if (state.opts[oi] != null) out.push(panel.getAttribute('data-label') + ': ' + state.opts[oi]);
      });
      return out;
    }

    function sentText() {
      var parts = ['Fahrzeug: ' + car + (state.year ? ' (Baujahr ' + yearLabel() + ')' : '')];
      if (camIndex > -1 && state.cam) parts.push('Rückfahrkamera: ' + CAM_TEXT[state.cam]);
      parts = parts.concat(optLabels());
      parts.push('Display-Foto: ' + (state.photo === 'upload' ? 'hochgeladen' : 'kommt per WhatsApp'));
      var v = variant();
      if (v) parts.push('Preis: ' + v.price);
      return parts.join(' · ');
    }

    function need() {
      var k = key(state.i);
      if (k === 'baujahr' && !state.year) return 'Bitte Baujahr wählen';
      if (k === 'kamera' && !state.cam) return 'Bitte eine Option wählen';
      if (k === 'opt' && state.opts[panels[state.i].getAttribute('data-opt-index')] == null) return 'Bitte auswählen';
      if (k === 'kamera' || k === 'opt') {
        var v = variant();
        if (!v) return 'Diese Kombination gibt es nicht – frag uns per WhatsApp.';
        if (!v.available) return 'Gerade nicht verfügbar – frag uns per WhatsApp.';
      }
      return '';
    }

    function setSum(name, text) {
      var el = $('[data-q-sum="' + name + '"]');
      if (!el) return;
      el.textContent = text || '–';
      el.classList.toggle('is-empty', !text);
    }

    function waHref() {
      var t = 'Hallo Quaglia CarPlay, hier das Foto von meinem Display – ' + car + (state.year && state.year !== 'unbekannt' ? ' (' + state.year + ')' : '') + '. Der Termin ist gebucht.';
      return 'https://wa.me/' + wa + '?text=' + encodeURIComponent(t);
    }

    function render(focus) {
      var k = key(state.i);
      var n = need();
      panels.forEach(function (panel, idx) { panel.hidden = idx !== state.i; });
      Array.prototype.forEach.call(stepsEl.children, function (li, idx) {
        li.classList.toggle('is-done', idx < state.i);
        li.classList.toggle('is-current', idx === state.i);
        li.querySelector('.q-as__dot').textContent = idx < state.i ? '✓' : String(idx + 1);
        if (idx === state.i) li.setAttribute('aria-current', 'step');
        else li.removeAttribute('aria-current');
      });
      countEl.textContent = 'Schritt ' + (state.i + 1) + ' von ' + panels.length;

      navEl.hidden = k === 'fertig';
      backBtn.hidden = state.i === 0 || state.booked;
      nextBtn.hidden = k === 'termin';
      nextBtn.disabled = !!n;
      nextBtn.textContent = key(state.i + 1) === 'termin' ? 'Weiter zur Terminwahl' : 'Weiter';
      if (k === 'termin') needEl.textContent = state.booked ? 'Termin gebucht – einen Moment …' : 'Wähle oben im Kalender Tag und Uhrzeit.';
      else needEl.textContent = n;

      setSum('year', yearLabel());
      setSum('cam', state.cam ? CAM_TEXT[state.cam] : '');
      setSum('photo', state.photo === 'upload' ? 'hochgeladen' : (state.photo === 'later' ? 'per WhatsApp' : ''));
      setSum('termin', state.booked ? 'gebucht' : '');
      var v = variant();
      if (v) setSum('total', v.price);
      var sent = $('[data-q-sent]');
      if (sent) sent.textContent = sentText();

      if (waBtn) {
        waBtn.hidden = !(k === 'fertig' && state.photo !== 'upload');
        waBtn.href = waHref();
      }
      if (k === 'termin') initCal();

      if (focus) {
        if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var h = panels[state.i].querySelector('.q-as__q');
        if (h) { try { h.focus({ preventScroll: true }); } catch (err) { h.focus(); } }
      }
    }

    function go(i) {
      state.i = Math.max(0, Math.min(panels.length - 1, i));
      render(true);
    }

    function pick(buttons, active) {
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === active ? 'true' : 'false'); });
    }

    var yearBtns = $$('[data-q-year]');
    yearBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.year = b.getAttribute('data-q-year');
        pick(yearBtns, b);
        render();
      });
    });
    var yearSelect = $('[data-q-year-select]');
    if (yearSelect) yearSelect.addEventListener('change', function () { state.year = yearSelect.value || null; render(); });

    var camBtns = $$('[data-q-cam]');
    camBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.cam = b.getAttribute('data-q-cam');
        pick(camBtns, b);
        render();
      });
    });

    $$('[data-q-panel="opt"]').forEach(function (panel) {
      var oi = panel.getAttribute('data-opt-index');
      var btns = Array.prototype.slice.call(panel.querySelectorAll('[data-q-optval]'));
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          state.opts[oi] = b.getAttribute('data-q-optval');
          pick(btns, b);
          render();
        });
      });
    });

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var f = fileInput.files && fileInput.files[0];
        state.file = f || null;
        state.photo = f ? 'upload' : null;
        if (uploadEl) uploadEl.classList.toggle('is-set', !!f);
        if (fileNameEl) fileNameEl.textContent = f ? 'Foto ausgewählt: ' + f.name : 'Foto jetzt hochladen';
        if (laterBtn) laterBtn.setAttribute('aria-pressed', 'false');
        render();
      });
    }
    if (laterBtn) {
      laterBtn.addEventListener('click', function () {
        state.photo = 'later';
        state.file = null;
        if (fileInput) fileInput.value = '';
        if (uploadEl) uploadEl.classList.remove('is-set');
        if (fileNameEl) fileNameEl.textContent = 'Foto jetzt hochladen';
        laterBtn.setAttribute('aria-pressed', 'true');
        render();
      });
    }

    nextBtn.addEventListener('click', function () { if (!need()) go(state.i + 1); });
    backBtn.addEventListener('click', function () { if (state.i > 0 && !state.booked) go(state.i - 1); });

    function loadCalendly(cb) {
      if (window.Calendly && window.Calendly.initInlineWidget) { cb(); return; }
      if (!document.querySelector('script[src*="assets.calendly.com/assets/external/widget.js"]')) {
        var s = document.createElement('script');
        s.src = 'https://assets.calendly.com/assets/external/widget.js';
        s.async = true;
        document.head.appendChild(s);
      }
      var tries = 0;
      (function wait() {
        if (window.Calendly && window.Calendly.initInlineWidget) cb();
        else if (tries++ < 100) setTimeout(wait, 150);
        else cal.innerHTML = '<p class="q-as__cal-loading">Der Kalender konnte nicht geladen werden. Bitte Seite neu laden oder schreib uns per WhatsApp.</p>';
      })();
    }

    function initCal() {
      if (state.booked || !cal) return;
      var sig = sentText();
      if (sig === calSig) return;
      calSig = sig;
      cal.innerHTML = '<p class="q-as__cal-loading">Kalender wird geladen …</p>';
      loadCalendly(function () {
        if (sig !== calSig) return;
        cal.innerHTML = '';
        var url = root.getAttribute('data-url');
        url += (url.indexOf('?') > -1 ? '&' : '?') + 'hide_gdpr_banner=1&hide_event_type_details=1&primary_color=7a4e26';
        window.Calendly.initInlineWidget({ url: url, parentElement: cal, prefill: { customAnswers: { a1: sig } } });
      });
    }

    function save() {
      if (state.saved) return Promise.resolve();
      if (state.saving) return state.saving;
      var v = variant() || variants[0];
      var fd = new FormData();
      fd.append('id', String(v.id));
      fd.append('quantity', '1');
      fd.append('properties[Baujahr]', state.year === 'unbekannt' ? 'unbekannt' : (state.year || 'nicht angegeben'));
      if (camIndex > -1 && state.cam) fd.append('properties[Rückfahrkamera]', CAM_TEXT[state.cam]);
      if (state.file) fd.append('properties[Display-Foto]', state.file);
      else fd.append('properties[Display-Foto]', 'kommt per WhatsApp');
      fd.append('properties[Einbautermin]', 'gebucht');
      state.saving = fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          return fetch(routeRoot + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Termin gebucht': 'Ja', 'Calendly-Termin-ID': state.eventId } })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('update'); state.saved = true; })
        .catch(function (err) { state.saving = null; throw err; });
      return state.saving;
    }

    window.addEventListener('message', function (e) {
      if (e.origin !== 'https://calendly.com' || !e.data || e.data.event !== 'calendly.event_scheduled') return;
      if (state.booked || key(state.i) !== 'termin') return;
      var payload = e.data.payload || {};
      state.eventId = payload.event && payload.event.uri ? String(payload.event.uri).split('/').pop() : '';
      state.booked = true;
      save().catch(function () {});
      render();
      setTimeout(function () { go(indexOf('fertig')); }, 1800);
    });

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        checkoutBtn.disabled = true;
        statusEl.classList.remove('is-error');
        statusEl.textContent = 'Einen Moment …';
        save().then(function () {
          window.location.href = routeRoot + 'checkout';
        }).catch(function () {
          checkoutBtn.disabled = false;
          statusEl.classList.add('is-error');
          statusEl.textContent = 'Das hat nicht geklappt. Bitte nochmals versuchen – dein Termin ist trotzdem gebucht. Bei Fragen: WhatsApp.';
        });
      });
    }

    render(false);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-q-assist]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();